import { ReactNode } from 'react';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import H3 from '@sdk/components/ui/typography/H3';

type Props = {
  children: ReactNode;
};

export const ComposeConversationTitle = ({ children }: Props) => (
  <H3 bold themeColor={ThemeColorType.primary}>
    {children}
  </H3>
);
